@if (matterClassData$ | async) {}
<div class="one" fxLayout="column" [formGroup]="matterdetailForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.FIRMROLE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FIRMROLE),
      }"
    >
      <mat-label>Acting on behalf of</mat-label>
      <mat-select
        name="FIRMROLE"
        formControlName="FIRMROLE"
        matTooltip="{{ toolTipList ? toolTipList.FIRMROLE?.HOVER : '' }}"
      >
        @for (roleoption of ContactRoleData; track roleoption) {
          <mat-option value="{{ roleoption.LOOKUPFULLVALUE }}">
            {{ roleoption.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-select>
      @if (testBool && toolTipList.FIRMROLE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.FIRMROLE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.FIRMROLE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      class="example pr-1"
      fxFlex="50"
      appearance="outline"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.OTHERSIDEROLE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.OTHERSIDEROLE),
      }"
    >
      <mat-label>Acting against</mat-label>
      <mat-select
        name="OTHERSIDEROLE"
        formControlName="OTHERSIDEROLE"
        matTooltip="{{ toolTipList ? toolTipList.OTHERSIDEROLE?.HOVER : '' }}"
      >
        @for (roleoption of ContactRoleData; track roleoption) {
          <mat-option value="{{ roleoption.LOOKUPFULLVALUE }}">
            {{ roleoption.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-select>
      @if (testBool && toolTipList.OTHERSIDEROLE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.OTHERSIDEROLE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.OTHERSIDEROLE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center " fxFlex="1 0 auto">
    <mat-checkbox class="example pr-1 pl-[4px]" formControlName="FIRMDONTSHOWADDRESS" fxFlex="100">
      Don't Use Client Address
    </mat-checkbox>
    <mat-icon class="mr-8 cursor-pointer" (click)="tooltipOpen('clinet address')">
      help_outline
    </mat-icon>
  </div>

  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="100" [ngClass]="{'has-error':errorWarningData.Error?.RELINECLIENT,'has-warning':errorWarningData.Warning?.RELINECLIENT}">
    <mat-label>"Re" Line when writing to client</mat-label>
    <textarea matInput formControlName="RELINECLIENT" matTooltip="{{(toolTipList)?toolTipList.RELINECLIENT?.HOVER:''}}" [matTooltipPosition]="toolTipPostion"></textarea>
    <div  *ngIf="testBool && toolTipList?.RELINECLIENT" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList.RELINECLIENT.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.RELINECLIENT.COPYVALUE:'')">file_copy</mat-icon></div>
  </mat-form-field> -->

    <mat-form-field
      appearance="outline"
      class="full-width pr-1"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData?.Error?.RELINECLIENT),
        'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.RELINECLIENT),
      }"
    >
      <mat-label>"Re" Line when writing to client</mat-label>

      <textarea
        matInput
        formControlName="RELINECLIENT"
        [matTooltip]="toolTipList?.RELINECLIENT?.HOVER || ''"
        [matTooltipPosition]="toolTipPostion"
        rows="3"
        (keydown.enter)="$event.stopImmediatePropagation()"
      ></textarea>
      @if (testBool && toolTipList?.RELINECLIENT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RELINECLIENT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.RELINECLIENT.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center " fxFlex="1 0 auto">
    <mat-checkbox
      class="example pr-1 pl-[4px]"
      formControlName="RELINECLIENTCLIENTASPREFIX"
      fxFlex="50"
    >
      Add Client As Prefix
    </mat-checkbox>
    <mat-checkbox
      class="example pr-1 pl-[4px]"
      formControlName="RELINECLIENTOTHERSIDEASSUFFIX"
      fxFlex="50"
    >
      Add Other Side As Suffix
    </mat-checkbox>
  </div>

  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="100" [ngClass]="{'has-error':errorWarningData.Error?.RELINEOTHERPARTIES,'has-warning':errorWarningData.Warning?.RELINEOTHERPARTIES}">
  <mat-label>"Re" when writing to other parties</mat-label>
  <textarea matInput formControlName="RELINEOTHERPARTIES" matTooltip="{{(toolTipList)?toolTipList.RELINEOTHERPARTIES?.HOVER:''}}" [matTooltipPosition]="toolTipPostion"></textarea>
  <div  *ngIf="testBool && toolTipList.RELINEOTHERPARTIES" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList.RELINEOTHERPARTIES.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.RELINEOTHERPARTIES?.COPYVALUE:'')">file_copy</mat-icon></div>
</mat-form-field> -->

    <mat-form-field
      appearance="outline"
      class="full-width pr-1"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData?.Error?.RELINEOTHERPARTIES),
        'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.RELINEOTHERPARTIES),
      }"
    >
      <mat-label>"Re" when writing to other parties</mat-label>

      <textarea
        matInput
        formControlName="RELINEOTHERPARTIES"
        [matTooltip]="toolTipList?.RELINEOTHERPARTIES?.HOVER || ''"
        [matTooltipPosition]="toolTipPostion"
        (keydown.enter)="$event.stopImmediatePropagation()"
        rows="3"
      ></textarea>
      @if (testBool && toolTipList.RELINEOTHERPARTIES) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RELINEOTHERPARTIES.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.RELINEOTHERPARTIES?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center " fxFlex="1 0 auto">
    <mat-checkbox
      class="example pr-1 pl-[4px]"
      formControlName="RELINEOTHERPARTIESCLIENTASPREFIX"
      fxFlex="50"
    >
      Add Client As Prefix
    </mat-checkbox>
    <mat-checkbox
      class="example pr-1 pl-[4px]"
      formControlName="RELINEOTHERPARTIESOTHERSIDEASSUFFIX"
      fxFlex="50"
    >
      Add Other Side As Suffix
    </mat-checkbox>
  </div>
</div>
